import API from '@/views/Fdc/Apis/'
import EqpTree from '@/components/EqpTree/EqpTree'

/**
 * Preprocessing > Preprocessing Plan
 * Preprocessing Plan 관리
 */
export default {
  name: 'PreprocessingPlan',
  components: {
    EqpTree
  },
  watch: {
    /**
     * corrYn 변화 감지
     * @param {String} val corrYn value
     */
    corrYn: function (val) {
      if (val === 'correction' && (this.corrType !== 'Mean' && this.corrType !== 'Regression')) {
        this.corrType = 'Mean'
      }
    }
  },
  beforeMount () {
    this.initColumns()
  },
  mounted () {
  },
  methods: {
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.preprocParam = { ...node }
      this.selectedTreeNode = node
    },
    /**
     * 컬럼 설정
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName' },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_DESC'), field: 'paramDesc' },
        { headerName: this.$t('fdc.COMMON.COLUMN.VID'), field: 'vid', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.VID_TYPE'), field: 'vidType', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', width: 180 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 150, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 100 }
      ]
    },
    async gridSelectionChanged (rows) {
      if (rows.length === 1) {
        this.preprocPlanInfo = { ...rows[0] }
        this.selectedParamName = this.preprocPlanInfo.paramName

        let obj = {
          fab: this.preprocPlanInfo.fab,
          eqpId: this.preprocPlanInfo.eqpId,
          moduleId: this.preprocPlanInfo.moduleId,
          paramName: this.preprocPlanInfo.paramName
        }
        try {
          let response = await API.FdcPreproc.getPreprocPlanInfo(obj)
          this.canDelete = response !== '' || false
          this.corrYn = response.nullYn === 'Y' ? 'remove' : response.corrYn === 'Y' ? 'correction' : ''
          this.corrType = response.corrType
          this.corrRefSize = response.corrRefSize
          this.normzYn = response.normzYn === 'Y' || false
          this.meanVal = response.meanVal
          this.stdevVal = response.stdevVal
        } catch (error) {
          console.log(error)
        }
      } else {
        // TODO: 처리 필요시 추가
      }
    },
    /**
     * Preprocessing Plan 검색
     */
    searchModel () {
      this.preprocPlanInfo = {}
      this.selectedParamName = null

      if (!this.preprocParam.hasOwnProperty('detail') || this.preprocParam.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.MODULE')]))
        return false
      } else {
        this.getParameterList(this.preprocParam)
        this.refreshPlanInfo()
      }

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )
    },
    /**
     * Preprocessing Plan reset
     */
    deletePlanConfirm () {
      let that = this
      let data = { ...this.preprocPlanInfo }
      if (!data.hasOwnProperty('fab')) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Plan Info']))
        return false
      }

      if (!this.canDelete) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Plan Info']))
        return false
      }

      this.$dialog.confirm({
        message: this.$t('fdc.COMMON.MESSAGE.CONFIRM_RESET'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          that.resetPreprocPlanInfo()
        }
      })
    },
    /**
     * Data 초기화
     */
    refreshPlanInfo () {
      this.corrYn = ''
      this.corrType = ''
      this.corrRefSize = null
      this.normzYn = false
      this.meanVal = null
      this.stdevVal = null
    },
    /**
     * Preprocessing Plan 재조회
     */
    refreshParamInfo () {
      if (this.preprocParam.detail.moduleId === '') {
        // this.$dialog.alert(this.$t('fdc.FDC_AUTO_MODEL_PLAN.ALERTS.TREE_CONDITION'))
        // return false
      } else {
        this.getParameterList(this.preprocParam)
      }
    },
    /**
     * Preprocessing Plan 삭제
     */
    async resetPreprocPlanInfo () {
      let data = { ...this.preprocPlanInfo }
      let plan = {
        fab: data.fab,
        eqpId: data.eqpId,
        moduleId: data.moduleId,
        paramName: data.paramName
      }

      try {
        let response = await API.FdcPreproc.deletePreprocPlanInfo(plan)
        if (response !== null) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
          this.refreshPlanInfo()
          this.refreshParamInfo()
        }
      } catch (error) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
      }
    },
    /**
     * Preprocessing Plan 저장
     */
    async savePreprocPlanInfo () {
      let data = { ...this.preprocPlanInfo }
      if (!data.hasOwnProperty('fab')) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Plan Info']))
        return false
      }

      let plan = {
        fab: data.fab,
        eqpId: data.eqpId,
        moduleId: data.moduleId,
        paramName: data.paramName,
        nullYn: this.corrYn === 'remove' ? 'Y' : 'N',
        corrYn: this.corrYn === 'correction' ? 'Y' : 'N',
        corrType: this.corrType || 'NA',
        corrRefSize: isNaN(parseInt(this.corrRefSize)) ? 3 : parseInt(this.corrRefSize),
        normzYn: this.normzYn ? 'Y' : 'N',
        meanVal: isNaN(parseFloat(this.meanVal)) ? 1 : parseFloat(this.meanVal),
        stdevVal: isNaN(parseFloat(this.stdevVal)) ? 1 : parseFloat(this.stdevVal)
      }

      // this.corrYn = this.corrYn
      this.corrType = plan.corrType
      this.corrRefSize = plan.corrRefSize
      this.normzYn = plan.normzYn === 'Y' || false
      this.meanVal = plan.meanVal
      this.stdevVal = plan.stdevVal

      try {
        let response = await API.FdcPreproc.savePreprocPlanInfo(plan)
        if (response !== null) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
          this.canDelete = true
          // this.refreshParamInfo()
        }
      } catch (error) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
      }
    },
    /**
     * Preprocessing Plan 목록 조회
     * @param {Object} node tree node 정보
     */
    async getParameterList (node) {
      // if (node.moduleId === '') {
      //   this.$dialog.alert(this.$t('fdc.FDC_PREPROCESSING.ALERTS.TREE_CONDITION'))
      //   return false
      // }
      let obj = {
        'fab': node.detail.fab,
        'eqpId': node.detail.eqpId,
        'moduleId': node.detail.moduleId
      }
      try {
        let data = await API.FdcPreproc.getPreprocPlanParamInfo(obj)
        if (data) {
          this.rowData = [...data]
          this.refreshPlanInfo()
          this.selectedParamName = null
        }
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * Preprocessing Plan 선택
     * @param {*} grid wijmo grid
     * @param {*} event event
     */
    async gridSectionChanged_legacy (grid, event) {
      this.preprocPlanInfo = { ...grid.selectedItems[0] }
      this.selectedParamName = this.preprocPlanInfo.paramName
      // let checked = grid.rows[e.row]._data._status.checked
      let obj = {
        fab: this.preprocPlanInfo.fab,
        eqpId: this.preprocPlanInfo.eqpId,
        moduleId: this.preprocPlanInfo.moduleId,
        paramName: this.preprocPlanInfo.paramName
      }

      try {
        let response = await API.FdcPreproc.getPreprocPlanInfo(obj)
        this.canDelete = response !== '' || false
        this.corrYn = response.nullYn === 'Y' ? 'remove' : response.corrYn === 'Y' ? 'correction' : ''
        this.corrType = response.corrType
        this.corrRefSize = response.corrRefSize
        this.normzYn = response.normzYn === 'Y' || false
        this.meanVal = response.meanVal
        this.stdevVal = response.stdevVal
      } catch (error) {
        console.log(error)
      }
    }
  },
  data () {
    return {
      canDelete: true, // 삭제 가능 여부
      preprocPlanInfo: {}, // 선택된 Preprocessing Plan 정보
      selectedParamName: null, // 선택된 Parameter 정보
      preprocParam: {}, // 선택된 EQP Tree node 정보
      corrYn: '', // Preprocessing option (Removal Value / Data Correction)
      corrType: '', // Data Correction Type
      corrRefSize: null, // Data Correction Reference Size
      normzYn: false, // Normalization 여부
      meanVal: null, // Mean Value
      stdevVal: null, // Stdev Value
      // paramList: [], // Preprocessing Plan row data
      // paramListColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.FAB'), binding: 'fab', readOnly: true, width: 80 },
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', readOnly: true, width: 100 },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', readOnly: true, width: 100 },
      //   { label: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), binding: 'paramName', readOnly: true, width: 180 },
      //   { label: this.$t('fdc.COMMON.COLUMN.PARAM_DESC'), binding: 'paramDesc', readOnly: true, width: 200 },
      //   { label: this.$t('fdc.COMMON.COLUMN.VID'), binding: 'vid', readOnly: true, width: 100 },
      //   { label: this.$t('fdc.COMMON.COLUMN.VID_TYPE'), binding: 'vidType', readOnly: true, width: 80 },
      //   // { label: this.$t('fdc.COMMON.COLUMN.USABLE'), binding: 'useYn', readOnly: true, width: 80 },
      //   // { label: this.$t('fdc.COMMON.COLUMN.NUMBER_YN'), binding: 'numberYn', readOnly: true, width: 80 },
      //   // { label: this.$t('fdc.COMMON.COLUMN.VIRTUAL_YN'), binding: 'virtualYn', readOnly: true, width: 80 },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', readOnly: true, width: 180 },
      //   // { label: this.$t('fdc.COMMON.COLUMN.LIST_DELIMITER'), binding: 'listDelimiter', readOnly: true, width: 100 },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', readOnly: true, width: 120, dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', readOnly: true, width: 100 }
      // ], // Preprocessing Plan column 배열
      columns: [],
      rowData: [],
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }
    }
  }
}
